import {
  styled,
} from '@mui/material/styles'

export default styled
